import React from 'react';

export const themes = {
    light: {
        elementControls: {
            section: { bg: '#2b3556', fg: '#fff' },
            row: { bg: '#4d05e8', fg: '#fff' },
            column: { bg: '#e600ad', fg: '#fff' },
            default: { bg: '#2b3556', fg: '#fff' },
        },
        buttons: {
            info: { bg: '#4d05e8', fg: '#fff' },
            dark: { bg: '#2b3556', fg: '#fff' },
            danger: { bg: '', fg: '' },
            warning: { bg: '#e600ad', fg: '#fff' },
            primary: { bg: '#0062ff', fg: '#fff' },
        },
        primary: { fg: '#0062ff', bg: '#fff', color300: '#757b8a' },
        inputBorder: '#e5ebf0',
        borderPaleGrey: '#e5ebf0',
        inputBg: '#f4f6f9',
        headerBg: '#ffffff',
        modalBg: '#f4f6f9',
        titleText: '#171a21',
        bodyText: '#464a53',
        disabledText: '#a7a7a7',
    },
    dark: {},
};

export const ThemeContext = React.createContext(themes.light);
export const ThemeContextProvider = ThemeContext.Provider;
